// Клиент эндпоинтов тарифов.
//
// Публичный GET намеренно ходит мимо `request()` из auth: тот при 401 дёргает
// общий обработчик «нужен вход», а витрину читают до регистрации, и любая
// ошибка сети здесь должна кончаться встроенным контентом, а не модалкой.
import { request } from '../auth/request';
import type { ApiResult } from '../auth/request';
import type { PricingDoc } from './content';

export interface PricingDocView {
  /** `null` — админ ничего не сохранял, страница рисует встроенное. */
  doc: PricingDoc | null;
  updatedAt: number | null;
  updatedBy: string;
}

/**
 * Документ для страницы. Сеть недоступна, сервера нет, ответ битый — во всех
 * случаях `null`: страница обязана нарисоваться, пусть и на дефолтах.
 */
export async function fetchPublicPricing(): Promise<PricingDoc | null> {
  try {
    const res = await fetch('/api/pricing', { headers: { accept: 'application/json' } });
    if (!res.ok) return null;
    const body: unknown = await res.json();
    const doc = (body as { doc?: unknown } | null)?.doc;
    return doc && typeof doc === 'object' ? (doc as PricingDoc) : null;
  } catch {
    return null;
  }
}

export function fetchAdminPricing(): Promise<ApiResult<PricingDocView>> {
  return request('/api/admin/pricing');
}

/** `doc: null` сбрасывает контент к встроенному — сервер удаляет строку. */
export function saveAdminPricing(doc: PricingDoc | null): Promise<ApiResult<PricingDocView>> {
  return request('/api/admin/pricing', { method: 'PUT', json: { doc } });
}
